import connectHostCookie from '@atlassian/connect-js-cookie';
import connectHostHistory from '@atlassian/connect-js-history';
import connectHostRequest from '@atlassian/connect-js-request';
import type { ACJSHost } from '../../../../types.tsx';
import { getToken, getContext } from '../../context/main.tsx';
import { _shouldThrottle, go, reload } from '../../navigator/module.tsx';
import { getCurrentUser, getLocale, getTimeZone, getUser } from './user.tsx';

export const registerCoreModules = async (connectHost: ACJSHost) => {
	connectHost.defineModule('cookie', connectHostCookie);
	connectHost.defineModule('history', connectHostHistory);
	connectHost.defineModule(connectHostRequest);
	connectHost.defineModule('navigator', { _shouldThrottle, go, reload });
	connectHost.defineModule('user', { getCurrentUser, getLocale, getTimeZone, getUser });
	connectHost.defineModule('context', { getToken, getContext });
};
